<template>
  <section id="features">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-row justify="space-around">
            <v-col
              v-for="feat in features"
              :key="feat.title"
              class="px-8 my-8"
              cols="12"
              xs="12"
              offset-xs="0"
              sm="6"
              offset-sm="0"
              md="4"
              offset-md="0"
            >
              <div class="text-purple text-center" v-html="feat.svg"></div>
              <h3 class="title font-weight-bold mb-2 text-center not-black">
                {{ feat.title }}
              </h3>
              <div class="body-1 text-center" v-html="feat.description"></div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          title: 'Goals and Habits',
          description: `<strong class="text-pink">Combine your life goals with habits</strong> and you'll be set to succeed. Goals are a great way to <strong class="text-pink">stay motivated</strong> and increase your willpower while habits will <strong class="text-pink">boost your self-discipline</strong> and help you become the best version of yourself.`,
          svg: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
  <path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
</svg>`,
        },
        {
          title: 'Weekly review',
          description: `Spend some <strong class="text-pink">time to reflect every week,</strong> analyze what is working, identify blockers and find ways to be more productive. The weekly review allows you to compare your progress with previous weeks and adjust. <strong class="text-pink">Work smarter not harder.</strong>`,
          svg: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
</svg>`,
        },
        {
          title: 'Planning and tracking',
          description: `Review a ton of metrics of your progress with your habits and goals. Receive a <strong class="text-pink">weekly score based on your progress</strong>, build up momentum and improve every week.`,
          svg: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
  </svg>`,
        },
        //   {
        //     title: 'Track Goals & Habits',
        //     description: `Setting up long term Goals is a great way to start changing your life and <strong class="text-purple">increase your willpower and self-discipline</strong>.
        // Developing <strong class="text-purple">good Habits will last</strong> and will allow you to <strong class="text-purple">exceed your Goals</strong>.`,
        //     img: require('@/assets/features/goals.jpg'),
        //   },
        //   {
        //     title: 'Save your Milestones and Moticvations',
        //     description: `The best way to track your progress is to <strong class="text-purple">quantify it</strong>. Check the number of tasks completed, pending and in progress, when did you start, milestones and more.
        // <strong class="text-purple">Unlock achievements</strong> every step you make.`,
        //     img: require('@/assets/features/checks2.jpg'),
        //   },
        //   {
        //     title: 'Analyse your progress with our guided weekly review ceremony',
        //     description: `The key in the process. You will look back and forward.
        //       <strong class="text-purple">Evaluate your weekly progress</strong> and identify what went well and what you could do better.
        //       <strong class="text-purple">Apply lessons learned</strong> to the following week.`,
        //     img: require('@/assets/features/ceremony1.jpg'),
        //   },
        //   {
        //     title: 'Curated resources from our library',
        //     description: `We're here to help. We've
        //       <strong class="text-purple">
        //         selected and organized a ton of articles, exercises and other resources
        //       </strong> to help you. Have you found something useful? Send it to us and we'll include it!`,
        //     img: require('@/assets/features/resources.jpg'),
        //   },
        //   {
        //     title: 'Privacy friendy: no cookies, we protect your data',
        //     description: `Your data is yours and only yours. We will <strong class="text-purple">never share any of your
        //       data with third parties</strong>, advertising companies etc... We <strong class="text-purple">don't store unnecesary cookies in your browser</strong> or track you accross the web in any way.`,
        //     img: require('@/assets/features/private1.jpg'),
        //   },
        //   {
        //     title: 'Support an independent company',
        //     description: `Your data is yours and only yours. We will <strong class="text-purple">never share any of your
        //       data with third parties</strong>, advertising companies etc... We <strong class="text-purple">don't store unnecesary cookies in your browser</strong> or track you accross the web in any way.`,
        //     img: require('@/assets/features/friends.png'),
        //   },
      ],
    }
  },
}
</script>

<style scoped>
strong {
  color: #805ad5 !important;
}
</style>
